import React from "react";
import CircularLoad from "../loading/CircularLoad";

interface ButtonProps {
  text: string;
  type: string;
  handleClick?: any;
  isSubmitting?: boolean;
  dirty?: boolean;
  color?: string;
  hoverColor?: string;
  loadColor?: string;
  textColor?: string;
  border?: string;
  borderColor?: string;
  height?: number | string;
  width?: string;
  rounded?: string;
}

const Button: React.FC<ButtonProps> = ({
  handleClick,
  isSubmitting,
  color,
  hoverColor,
  loadColor,
  textColor,
  text,
  dirty,
  type,
  border,
  borderColor,
  height,
  width,
  rounded,
}) => {
  return (
    <button
      type={type as any}
      disabled={isSubmitting || dirty === false ? true : false}
      onClick={handleClick}
      className={
        " focus:ring-0 focus:outline-none " +
        `${rounded ? rounded : "rounded-full"} ` +
        `${color ? color : "bg-softPink"}  h-${
          height !== undefined ? ` ${height} ` : " h-9 "
        } ${width !== undefined ? ` ${width} ` : " w-36 "}  ` +
        (isSubmitting || dirty === false
          ? "cursor-not-allowed"
          : `hover:${hoverColor ? hoverColor : "bg-opacity-70"}`) +
        (border ? ` ${border} ${borderColor}` : "")
      }
    >
      {isSubmitting ? (
        <div className="flex justify-center">
          <CircularLoad
            color={loadColor ? loadColor : "#ffffff"}
            height={17}
            width={17}
          />
        </div>
      ) : (
        <h1
          className={
            "md:text-base text-xs " + (textColor ? textColor : "text-white")
          }
        >
          {text}
        </h1>
      )}
    </button>
  );
};

export default Button;
